// extracted by mini-css-extract-plugin
export default {"mainContainer":"GetStarted_mainContainer__fl7zY","field":"GetStarted_field__Wt55N","add_bg_img":"GetStarted_add_bg_img__wPjoE","searchInput":"GetStarted_searchInput__XsmNW"};